import { render, staticRenderFns } from "./data-desc.vue?vue&type=template&id=18f02a6b&scoped=true&"
import script from "./data-desc.vue?vue&type=script&lang=js&"
export * from "./data-desc.vue?vue&type=script&lang=js&"
import style0 from "./data-desc.vue?vue&type=style&index=0&id=18f02a6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f02a6b",
  null
  
)

export default component.exports